import { useState } from "react";
import api from "../api";
import { Modal } from "./ui";

const personName = (p) => `${p.first_name || ""} ${p.last_name || ""}`.trim();

export function ReviewRequestButton({ name, email, phone }) {
  const [open, setOpen] = useState(false);
  const [defs, setDefs] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [results, setResults] = useState(null);
  const [adding, setAdding] = useState(false);
  const [query, setQuery] = useState("");
  const [directory, setDirectory] = useState(null);

  const openModal = async () => {
    setOpen(true); setResults(null); setAdding(false); setQuery("");
    try {
      const r = await api.get("/appointments/review-request/defaults?name=" + encodeURIComponent("{nome}"), { noCache: true });
      setDefs(r.data);
      setSubject(r.data.subject);
      setBody(r.data.body);
      setRecipients([{ name: name || "", email, phone, channel: email ? "email" : phone ? "whatsapp" : "" }]);
    } catch (e) { alert(e.response?.data?.detail || e.message); setOpen(false); }
  };

  const loadDirectory = async () => {
    if (directory) return;
    try {
      const [ps, cs] = await Promise.all([api.get("/persons"), api.get("/companies")]);
      setDirectory([
        ...ps.data.map((p) => ({ key: `p-${p.id}`, name: personName(p), email: p.email, phone: p.phone, tipo: "persona" })),
        ...cs.data.map((c) => ({ key: `c-${c.id}`, name: c.name, email: c.email, phone: c.phone, tipo: "azienda" })),
      ]);
    } catch { setDirectory([]); }
  };

  const matches = () => {
    if (!directory || query.trim().length < 2) return [];
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    return directory
      .filter((d) => words.every((w) => `${d.name} ${d.email || ""}`.toLowerCase().includes(w)))
      .filter((d) => !recipients.some((r) => r.name === d.name && r.email === d.email))
      .slice(0, 6);
  };

  const addRecipient = (d) => {
    if (!d.email && !d.phone) { alert(`${d.name} non ha né email né telefono in anagrafica.`); return; }
    setRecipients((rs) => [...rs, { name: d.name, email: d.email, phone: d.phone, channel: d.email ? "email" : "whatsapp" }]);
    setQuery(""); setAdding(false);
  };
  const setChannel = (i, ch) => setRecipients((rs) => rs.map((r, j) => (j === i ? { ...r, channel: ch } : r)));
  const removeRecipient = (i) => setRecipients((rs) => rs.filter((_, j) => j !== i));

  const send = async () => {
    const valid = recipients.filter((r) => r.channel && (r.channel === "email" ? r.email : r.phone));
    if (!valid.length) { alert("Nessun destinatario con canale valido."); return; }
    setBusy(true);
    const out = [];
    for (const r of valid) {
      const to = r.channel === "email" ? r.email : r.phone;
      const personalBody = body.replaceAll("{nome}", r.name || "").replace("Gentile ,", "Buongiorno,");
      try {
        await api.post("/appointments/review-request", { channel: r.channel, to, name: r.name, subject, body: personalBody });
        out.push({ ...r, ok: true, to });
      } catch (e) {
        out.push({ ...r, ok: false, to, err: e.response?.data?.detail || e.message });
      }
    }
    setResults(out);
    setBusy(false);
  };

  return (
    <>
      <button className="btn sm" onClick={openModal} data-testid="review-request-btn" title="Invia un messaggio gentile con il link per la recensione Google (anche a più partecipanti)">⭐ Chiedi recensione Google</button>
      {open && (
        <Modal title="⭐ Chiedi la recensione Google" onClose={() => setOpen(false)}>
          {!defs ? <p className="muted">Caricamento…</p> : results ? (
            <div data-testid="review-request-done">
              {results.map((r, i) => (
                <p key={i} style={{ margin: "6px 0" }}>
                  {r.ok ? "✅" : "❌"} <strong>{r.name || r.to}</strong> — {r.channel === "email" ? "email a " + r.to : "WhatsApp a " + r.to}
                  {!r.ok && <span style={{ color: "#f87171" }}> · {r.err}</span>}
                </p>
              ))}
              <div className="toolbar"><div className="spacer" /><button className="btn primary" onClick={() => setOpen(false)}>Chiudi</button></div>
            </div>
          ) : (
            <>
              {!defs.google_review_link && (
                <p style={{ color: "#f59e0b", fontSize: 13 }} data-testid="review-request-nolink">
                  ⚠️ Link recensione Google non configurato (Impostazioni → Calendario): il messaggio conterrà un segnaposto.
                </p>
              )}
              <div className="field"><label>Destinatari (partecipanti all'incontro)</label>
                {recipients.map((r, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid var(--border)" }} data-testid={`review-recipient-${i}`}>
                    <strong style={{ minWidth: 140 }}>{r.name || "—"}</strong>
                    <label style={{ display: "flex", gap: 4, alignItems: "center", opacity: r.email ? 1 : 0.4, fontSize: 13 }}>
                      <input type="radio" name={`rr-ch-${i}`} disabled={!r.email} checked={r.channel === "email"} onChange={() => setChannel(i, "email")} />
                      ✉️ {r.email || "no email"}
                    </label>
                    <label style={{ display: "flex", gap: 4, alignItems: "center", opacity: r.phone ? 1 : 0.4, fontSize: 13 }}>
                      <input type="radio" name={`rr-ch-${i}`} disabled={!r.phone} checked={r.channel === "whatsapp"} onChange={() => setChannel(i, "whatsapp")} />
                      💬 {r.phone || "no tel."}
                    </label>
                    <span className="spacer" />
                    {recipients.length > 1 && <button className="btn sm danger" onClick={() => removeRecipient(i)} data-testid={`review-recipient-remove-${i}`}>✕</button>}
                  </div>
                ))}
                {adding ? (
                  <div style={{ marginTop: 8, position: "relative" }}>
                    <input autoFocus placeholder="Cerca persona o azienda (min 2 lettere)…" value={query} onChange={(e) => setQuery(e.target.value)} data-testid="review-add-search" />
                    {matches().map((d) => (
                      <div key={d.key} onClick={() => addRecipient(d)} style={{ padding: "6px 10px", cursor: "pointer", borderBottom: "1px solid var(--border)", fontSize: 13 }} data-testid={`review-add-opt-${d.key}`}>
                        {d.tipo === "azienda" ? "🏢" : "👤"} <strong>{d.name}</strong> <span className="muted">{[d.email, d.phone].filter(Boolean).join(" · ") || "nessun recapito"}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <button className="btn sm" style={{ marginTop: 8 }} onClick={() => { setAdding(true); loadDirectory(); }} data-testid="review-add-recipient">＋ Aggiungi partecipante</button>
                )}
              </div>
              <div className="field"><label>Oggetto (per invii via email)</label>
                <input value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="review-request-subject" />
              </div>
              <div className="field"><label>Messaggio (modificabile)</label>
                <textarea rows={9} value={body} onChange={(e) => setBody(e.target.value)} data-testid="review-request-body" />
                <p className="muted" style={{ fontSize: 12, marginTop: 4 }}>💡 <code>{"{nome}"}</code> viene sostituito automaticamente col nome di ciascun destinatario.</p>
              </div>
              <div className="toolbar">
                <div className="spacer" />
                <button className="btn" onClick={() => setOpen(false)}>Annulla</button>
                <button className="btn primary" onClick={send} disabled={busy} data-testid="review-request-send">
                  {busy ? "Invio…" : `Invia a ${recipients.filter((r) => r.channel).length} destinatari${recipients.filter((r) => r.channel).length === 1 ? "o" : ""}`}
                </button>
              </div>
            </>
          )}
        </Modal>
      )}
    </>
  );
}
